// extracted by mini-css-extract-plugin
export default {"root":"LandingPage_root__XCyK5","container":"LandingPage_container__wR3fb"};